/**
 * Detail template.
 */
import Content from '@components/sections/detail/ui/detailContent';
import Header from '@components/sections/detail/ui/detailHeader';
import Context, {
  DetailContextProps as Props,
} from '@shared/components/utils/context/detailContext';

/**
 * Renders the detail template and handles its context.
 */
export default function DetailTemplate(context: Props) {
  if (!context.asset) return null;
  return (
    <Context.Provider value={context}>
      <Header />
      <Content />
    </Context.Provider>
  );
}
